import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { ComponentLoader } from '../component-loader/component-loader.component';
import { UtilService, VwoService } from 'src/app/shared/services';

@Component({
  selector: 'app-thankyou-min-tip-head',
  standalone: true,
  imports: [CommonModule, SharedModule, ComponentLoader],
  templateUrl: './thankyou-min-tip-head.component.html',
  styleUrls: ['./thankyou-min-tip-head.component.scss']
})
export class ThankyouMinTipHeadComponent implements OnInit {

  @Input() order;

  showCsat = false;

  constructor(
    private util: UtilService,
    public vwo: VwoService
  ) { }

  ngOnInit(): void {
    this.showCsat = this.util.storage.get('csat_survey_done') && !this.util.storage.getFromSession('csat_survey_done') ? false : true;
  }
}
